module.exports = __webpack_public_path__ + "img/wall.32a7fba5.png";